// extracted by mini-css-extract-plugin
export default {"extraText":"DialogPopUp_extraText__4DL6r"};